var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxlFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bxl-facebook"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M6.39703 17.9986V9.80257H9.16203L9.57303 6.59357H6.39703V4.54957C6.39703 3.62357 6.65503 2.98957 7.98403 2.98957H9.66803V0.128569C8.84903 0.040569 8.02503 -0.00143097 7.20103 0.00156903C4.75703 0.00156903 3.07903 1.49357 3.07903 4.23257V6.58757H0.332031V9.79657H3.08503V17.9986H6.39703Z",
    fill: "#222222"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxlFacebook);
export default __webpack_public_path__ + "static/media/bxl-facebook.91e87ebb87822ecc5ee5bc28468f1a2d.svg";
export { ForwardRef as ReactComponent };